// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: デモページの削除
const AdminOpsDemoDeleteApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_demo_delete";

    const ExecAdminOpsDemoDeleteApi = async (pageName) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { page_name: pageName } });
    };

    return ExecAdminOpsDemoDeleteApi;
};

export default AdminOpsDemoDeleteApi;
